import { render, staticRenderFns } from "./CertificateManualMatching.vue?vue&type=template&id=79edf508"
import script from "./CertificateManualMatching.vue?vue&type=script&lang=js"
export * from "./CertificateManualMatching.vue?vue&type=script&lang=js"
import style0 from "./CertificateManualMatching.vue?vue&type=style&index=0&id=79edf508&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports